export default {
  buttons: {
    login: 'Login',
  },
  feedback: {
    incorrect_code: 'The code you entered is incorrect. Please try again.',
    expired_code: 'This code has expired. Please request a new one.',
    too_many_attempts: 'Too many attempts. Please wait a moment and try again.',
    unknown: 'Something went wrong while verifying your code. Please try again.',
    network_error: "We couldn't reach the server. Check your connection and try again.",
  },
};
